export default __webpack_public_path__ + "static/media/call-calling.5bc066d3.svg";